export const roleField = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
export const isPrincipalString = 'Usa|PRIN';
